import React, { Component } from "react";

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = { counter: props.val };
  }

  render() {
    let { counter } = this.state;
    this.r = setTimeout(() => {
      if (counter > 0.1) {
        this.setState({ counter: counter - 0.1 });
      }
    }, 100);

    return (
      <div className="contdownMain">
        <div className="contdownInner">
          <p
            style={{
              fontSize: "30px",
            }}
          >
            Starts in {counter.toFixed(1)} s
          </p>
        </div>
      </div>
    );
  }
}

export default Counter;
